import { SegmentedControl } from '../design'
import type { SegOption } from '../design'
import { useLang } from '../lang'

// The time-window control beside Live's activity line. It used to carry its own stylesheet —
// plain marked mono text — while the identical control on Stats and in the Directory was a
// chromed pill. They are one control now (SegmentedControl), wearing the plain treatment; this
// component survives only to turn the bootstrap's [label, hours] pairs into its options.
export function WindowPicker({
  windows,
  value,
  onChange,
}: {
  windows: [string, number][]
  value: number
  onChange: (hours: number) => void
}) {
  const { t } = useLang()
  const options: SegOption<number>[] = windows.map(([label, hours]) => ({ value: hours, label }))
  return (
    <SegmentedControl
      options={options}
      value={value}
      onChange={onChange}
      ariaLabel={t('Time window', 'Fráma ama')}
    />
  )
}
